import { SLUG_PATTERN, mahalluFromHost } from '@mahallu/shared';

/** Main domain for mahallu links, e.g. yourmahallu.rabitaone.in (ADR-0040). */
export const BASE_DOMAIN = ((import.meta.env.VITE_BASE_DOMAIN as string | undefined) ?? 'rabitaone.in').toLowerCase();

const KEY = 'rabita.mahalluLink';

/**
 * The mahallu this address points at: `<slug>.rabitaone.in`, or `?m=<slug>` locally (kept for the tab, so it
 * survives the sign-in steps). Null on app.rabitaone.in and the console.
 */
export function mahalluLink(): string | null {
  const fromHost = mahalluFromHost(window.location.hostname, BASE_DOMAIN);
  if (fromHost) return fromHost;
  const q = new URLSearchParams(window.location.search).get('m');
  try {
    if (q && SLUG_PATTERN.test(q)) sessionStorage.setItem(KEY, q);
    return sessionStorage.getItem(KEY);
  } catch {
    return q && SLUG_PATTERN.test(q) ? q : null;
  }
}

/** True on the console address (console.rabitaone.in); locally the console lives under /console. */
export const onConsoleHost = () => window.location.hostname.toLowerCase().startsWith('console.');
